import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import NewDesc from '../views/newDesc.vue'
import NewDesc1 from '../views/newDesc1.vue'
import NewDesc2 from '../views/newDesc2.vue'
import NewDesc3 from '../views/newDesc3.vue'
import NewDesc4 from '../views/newDesc4.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/newDesc',
    name: 'NewDesc',
    component: NewDesc
  },
  {
    path: '/newDesc1',
    name: 'NewDesc1',
    component: NewDesc1
  },
  {
    path: '/newDesc2',
    name: 'NewDesc2',
    component: NewDesc2
  },
  {
    path: '/newDesc3',
    name: 'NewDesc3',
    component: NewDesc3
  },
  {
    path: '/newDesc4',
    name: 'NewDesc4',
    component: NewDesc4
  },

]

const router = new VueRouter({
  mode: 'hash',
  routes
})

export default router
